import {
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { HiDocumentText, HiOutlineDotsVertical } from "react-icons/hi";
import {
  Link as RouterLink,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { Loading } from "src/common/Loading";
import { Pagination } from "src/common/Pagination";
import { SortableTh } from "src/common/SortableTh";
import { PageContent } from "src/layout/PageContent";
import { PageHeader, PageHeaderTitle } from "src/layout/PageHeader";
import { PropertiesFilterBar } from "src/routes/Properties/PropertiesFilterBar";
import { useAllPropertyOrganizationsQuery } from "src/routes/Properties/queries";

export const Properties = () => {
  const query = useAllPropertyOrganizationsQuery();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  if (query.isLoading || !query.data) {
    return <Loading />;
  }

  return (
    <>
      <PageHeader buttons={<PropertiesFilterBar />}>
        <PageHeaderTitle>GateHawk Properties</PageHeaderTitle>
      </PageHeader>
      <PageContent>
        <Table variant="simple">
          <Thead>
            <Tr>
              <SortableTh sortKey="name">Name</SortableTh>
              <SortableTh sortKey="contact">Admin Contact</SortableTh>
              <SortableTh sortKey="city">City</SortableTh>
              <SortableTh sortKey="state">State</SortableTh>
              <SortableTh sortKey="dealer">Dealer</SortableTh>
              <SortableTh sortKey="type">Type</SortableTh>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {query.data.result.map((property) => (
              <Tr key={property.propertyOrganizationId}>
                <Td>
                  <Link
                    as={RouterLink}
                    to={`/properties/${property.propertyOrganizationId}`}
                  >
                    <Text>{property.name}</Text>
                  </Link>
                </Td>
                <Td>{`${property.contact?.user.firstName} ${property.contact?.user.lastName}`}</Td>
                <Td>{property.city}</Td>
                <Td>{property.state}</Td>
                <Td>{property.dealer?.dba || property.dealer?.name}</Td>
                <Td>{property.propertyType}</Td>
                <Td>
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Actions"
                      icon={<HiOutlineDotsVertical />}
                      variant="clear"
                    >
                      Actions
                    </MenuButton>
                    <MenuList>
                      <MenuItem
                        justifyContent="space-between"
                        onClick={() => {
                          navigate(
                            `/properties/${property.propertyOrganizationId}`
                          );
                        }}
                      >
                        Property Details
                        <HiDocumentText />
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          unitName="property"
          unitPlural="properties"
          total={query.data.total}
          pageNumber={parseInt(searchParams.get("pageNumber") || "1")}
          pageSize={query.data.pageSize}
          onPageChange={(page) => {
            setSearchParams((prev) => {
              const next = new URLSearchParams(prev);
              next.set("pageNumber", page.toFixed(0));
              return next;
            });
          }}
        />
      </PageContent>
    </>
  );
};
